import { FunctionComponent, SVGProps } from "react"

const Svg: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32.547" height="20.117" viewBox="0 0 32.547 20.117" {...props}><path fill="#ff5f00" d="M11.873 2.15h8.801v15.816h-8.801z"/><path d="M12.433 10.058a10.041 10.041 0 0 1 3.842-7.908 10.058 10.058 0 1 0 0 15.816 10.041 10.041 0 0 1-3.842-7.908Z" fill="#eb001b"/><path d="M32.548 10.058a10.058 10.058 0 0 1-16.273 7.908 10.06 10.06 0 0 0 0-15.816 10.058 10.058 0 0 1 16.273 7.908Z" fill="#f79e1b"/></svg>
)

export default Svg
